import CryptoJS from 'crypto-js';

// 使用固定的32字节加密密钥
const ENCRYPTION_KEY = 'DEFI_PLATFORM_SECRET_KEY_2024_32CH';

// 使用简单的Base64编码
export const decryptUid = (encoded: string): string => {
  try {
    console.log(':', encoded);
    // 使用简单的Base64解码
    const decoded = atob(encoded);
    console.log(':', decoded);
    // 保存解码后的 uid 到 localStorage
    localStorage.setItem('decodedUid', decoded);
    return decoded;
  } catch (error) {
    console.error(':', error);
    throw new Error('解码失败');
  }
}; 